<template>
  <div>
    <div class="authority" v-if="status == true">
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
    <div v-else>
      <div class="box">
        <p class="returns" @click="back">返回首页</p>
        <span class="line">|</span>
        <p class="contract">系统设置</p>
        <span class="lines">></span>
        <p class="contract">账号管理</p>
      </div>
      <div class="p_btn">
        <div>
          <div class="mainTitle">权限组管理</div>
        </div>

        <button class="btn subbtn" @click="add">创建权限组</button>
      </div>
      <div style="margin-bottom: 16px">
        <span class="fiternum">权限组名称</span>
        <el-input
          placeholder="请输入权限组名称"
          @keyup.enter.native="searchEnterFun"
          v-model.trim="form.name"
          style="width: 250px; margin-right: 25px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="onsubmit"
          ></el-button>
        </el-input>
      </div>

      <div class="table">
        <el-table
          :data="list"
          :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
        >
          <el-table-column label="权限组" prop="name" min-width="15%">
          </el-table-column>
          <el-table-column
            label="账号数量"
            prop="relevanceNum"
            min-width="75%"
          ></el-table-column>

          <el-table-column label="操作" min-width="10%" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.type == 1"
                @click="onmodify(scope.row)"
                style="cursor: pointer"
              >
                <i
                  class="el-icon-edit-outline"
                  style="font-size: 12px; margin-right: 4px"
                ></i
                >编辑
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page
        :page="pageNum"
        :pagesize.sync="pageSize"
        :total="total"
        @currentChange="cur"
        @enter="cur"
        v-show="total > 0"
        :pageNum="pageNum"
      ></page>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
    //初始化数据
    this.loadData();
  },
  data() {
    return {
      status: false,
      fiternum: "",
      form: {
        name: "",
      },
      list: [],
      checkid: "",
      checkval: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      maskshow: false,
      masktype: "",
      id: "",
      addForm: {
        name: "",
        linkManName: "", //联系人名称
        mobile: "", // 联系人手机号
        email: "",
        unitType: "", // 公司类型
        registerType: "", // 注册类型
        legalPerson: "", // 法人名称
        legalPersonIdnumber: "", // 法人身份证号
        agent: "", // 代理人
        agentIdnumber: "", // 代理人身份证号
        registerNumberType: "", // 注册号类型
        registerNumber: "", // 注册号
        registerAddress: "", // 公司地址
        industry: "", // 行业
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入合同公司",
            trigger: "blur",
          },
        ],
        linkManName: [
          {
            required: true,
            message: "请输入联系人名称",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
        unitType: [
          {
            required: true,
            message: "请选择公司类型",
            trigger: "change",
          },
        ],
        registerType: [
          {
            required: true,
            message: "请选择注册类型",
            trigger: "change",
          },
        ],
        legalPerson: [
          {
            required: true,
            message: "请输入法人名称",
            trigger: "blur",
          },
        ],
        legalPersonIdnumber: [
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号格式不正确",
            trigger: "blur",
          },
        ],
        registerNumberType: [
          {
            required: true,
            message: "请选择注册号类型",
            trigger: "change",
          },
        ],
        registerNumber: [
          {
            required: true,
            message: "请输入注册号",
            trigger: "blur",
          },
        ],
        registerAddress: [
          {
            required: true,
            message: "请输入公司地址",
            trigger: "blur",
          },
        ],
        industry: [
          {
            required: true,
            message: "请输入行业",
            trigger: "blur",
          },
        ],
      },
      rrules: {
        name: [
          {
            required: true,
            message: "请输入合同公司",
            trigger: "blur",
          },
        ],
        link_man_name: [
          {
            required: true,
            message: "请输入联系人名称",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
        unit_type: [
          {
            required: true,
            message: "请选择公司类型",
            trigger: "change",
          },
        ],
        register_type: [
          {
            required: true,
            message: "请选择注册类型",
            trigger: "change",
          },
        ],
        legal_person: [
          {
            required: true,
            message: "请输入法人名称",
            trigger: "blur",
          },
        ],
        legal_person_idnumber: [
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号格式不正确",
            trigger: "blur",
          },
        ],
        register_number_type: [
          {
            required: true,
            message: "请选择注册号类型",
            trigger: "change",
          },
        ],
        register_number: [
          {
            required: true,
            message: "请输入注册号",
            trigger: "blur",
          },
        ],
        register_address: [
          {
            required: true,
            message: "请输入公司地址",
            trigger: "blur",
          },
        ],
        industry: [
          {
            required: true,
            message: "请输入行业",
            trigger: "blur",
          },
        ],
      },
      unitTypes: [
        {
          id: 0,
          value: "普通企业",
        },
        {
          id: 1,
          value: "社会团体",
        },
        {
          id: 2,
          value: "事业单位",
        },
        {
          id: 3,
          value: "民办非企业单位",
        },
        {
          id: 4,
          value: "党政及国家机构",
        },
      ],
      // registerTypes: [{id: 1, value: '代理人注册'},{id: 2, value: '法人注册'}],
      registerTypes: [
        {
          id: 2,
          value: "法人注册",
        },
      ],
      registerNumberTypes: [
        {
          id: 0,
          value: "组织机构代码号",
        },
        {
          id: 1,
          value: "多证合一,传递社会信用代码号",
        },
        {
          id: 2,
          value: "企业工商注册码",
        },
      ],
    };
  },
  methods: {
    aa() {},
    hqid(id) {
      this.checkid = id;
    },
    lkid() {
      this.checkid = "";
    },
    shut() {
      this.loadData();
    },
    //回车事件
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      this.pageNum = 1;
      // console.log('回车搜索',keyCode,e);
      if (keyCode == 13) {
        this.onsubmit();
      }
    },
    //搜索
    onsubmit() {
      this.pageNum = 1;

      this.loadData();
    },
    onreset() {
      this.pageNum = 1;
      this.form.name = "";
      this.loadData();
    },
    back() {
      this.$router.push({ path: "/main" });
    },
    // 加载合同公司列表
    loadData() {
      const params = {
        name: this.form.name,
        pageNow: this.pageNum,
        pageSize: this.pageSize,
      };
      return this.$axios
        .get("permissionGroup/getPermissionGroupList", {
          params,
        })
        .then((res) => {
          if (res.data.status == 2) {
            this.status = true;
          } else {
            this.list = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    add() {
      this.$router.push({
        path: "rightsGroups/addRightsGroups",
        edit: "",
      });
    },
    onmodify(row) {
      this.$router.push({
        path: "rightsGroups/addRightsGroups",
        query: {
          id: row.id,
          edit: true,
        },
      });
    },
    // 添加合同公司
    addContractCompany() {
      this.$refs.addForm.validate((status) => {
        if (status == true) {
          const companyBiz = {};
          companyBiz.contractCompanyName = this.addForm.name; // 合同公司名称
          companyBiz.linkManName = this.addForm.linkManName; // 联系人名称
          companyBiz.mobile = this.addForm.mobile; // 手机号
          companyBiz.email = this.addForm.email; // 邮箱
          companyBiz.unitType = this.addForm.unitType; // 公司类型
          companyBiz.registerType = this.addForm.registerType; // 注册类型
          companyBiz.legalPerson = this.addForm.legalPerson; // 法人名称
          companyBiz.legalPersonIdnumber = this.addForm.legalPersonIdnumber; // 法人身份证号
          companyBiz.agent = this.addForm.agent; // 代理人
          companyBiz.agentIdnumber = this.addForm.agentIdnumber; // 代理人身份证号
          companyBiz.registerNumberType = this.addForm.registerNumberType; // 注册号类型
          companyBiz.registerNumber = this.addForm.registerNumber; // 注册号
          companyBiz.registerAddress = this.addForm.registerAddress; // 公司地址
          companyBiz.industry = this.addForm.industry; // 行业
          return this.$axios
            .post("contractCompany/add", companyBiz)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.maskshow = false;
                this.loadData();
              } else {
                this.$message.success(res.data.message);
              }
            })
            .catch((err) => {
              //处理错误
              console.error(err);
            });
        }
      });
    },
    update(id) {
      this.maskshow = true;
      this.masktype = "updatecompany";
      this.checkval = id;
      this.checkval.unit_type = 1;
    },
    // 修改合同公司
    updateContractCompany() {
      this.$refs.form.validate((status) => {
        if (status == true) {
          const companyBiz = {};
          companyBiz.id = this.checkval.id;
          companyBiz.contractCompanyName = this.checkval.name; // 合同公司名称
          companyBiz.linkManName = this.checkval.link_man_name; // 联系人名称
          companyBiz.mobile = this.checkval.mobile; // 手机号
          companyBiz.email = this.checkval.email; // 邮箱
          companyBiz.unitType = this.checkval.unit_type; // 公司类型
          companyBiz.registerType = this.checkval.register_type; // 注册类型
          companyBiz.legalPerson = this.checkval.legal_person; // 法人名称
          companyBiz.legalPersonIdnumber = this.checkval.legal_person_idnumber; // 法人身份证号
          companyBiz.agent = this.checkval.agent; // 代理人
          companyBiz.agentIdnumber = this.checkval.agent_idnumber; // 代理人身份证号
          companyBiz.registerNumberType = this.checkval.register_number_type; // 注册号类型
          companyBiz.registerNumber = this.checkval.register_number; // 注册号
          companyBiz.registerAddress = this.checkval.register_address; // 公司地址
          companyBiz.industry = this.checkval.industry; // 行业
          return this.$axios
            .put("contractCompany/update", companyBiz)
            .then((res) => {
              this.$message.success(res.data.message);
              this.maskshow = false;
              this.loadData();
            })
            .catch((err) => {
              //处理错误
              console.error(err);
            });
        }
      });
    },
    // 删除合同公司
    deleteContractCompany(id) {
      this.$confirm("是否删除该合同公司", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.id = id;
          return this.$axios
            .delete("contractCompany/delete?id=" + this.id)
            .then((res) => {
              this.$message.success(res.data.message);
              this.loadData();
            });
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },

    //分页方法
    cur(val) {
      this.pageNum = val;
      this.loadData();
    },
    search() {
      this.pageNum = 1;
      this.loadData();
    },
    seal(id) {
      this.$router.push({
        path: "contractCompany/seal",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.tab_nav {
  border-bottom: none;
}

.form {
  margin: 23px 0;
}

.el-form-item {
  margin-bottom: 15px;
}

.span_bgc {
  padding: 3px 5px;
  background-color: #ccc9c9;
}

.span_bgc1 {
  padding: 3px 5px;
  background-color: #f3ff00;
}

.span_bgc2 {
  padding: 3px 5px;
  background-color: #6fff6f;
}

.span_bgc3 {
  padding: 3px 5px;
  background-color: #ff6161;
}
.box {
  display: flex;
  margin-top: 20px;

  .returns {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}
.smallTitle {
  font-size: 12px;
  font-weight: 400;
  color: #303140;
}
.filter {
  width: 100%;
  height: 57px;
  background: rgba(242, 245, 248, 1);
  border-radius: 4px;
  margin-bottom: 30px;
}
.fiternum {
  font-size: 12px;
  font-weight: 400;
  color: rgba(84, 85, 102, 1);
  margin-right: 10px;
  margin-left: 10px;
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
</style>
